import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'if0002',
    ecrans: ['00-2']
});

